module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av633-8183d3219ee47f4eaa9e97dc9761523f.jpg";